export default __webpack_public_path__ + "static/media/formapagamento.12bd22a4.png";